import React from 'react';

import { CrossIcon } from 'components/Icons';

import styles from './NotificationCloseButton.module.scss';

interface NotificationCloseButtonProps {
  closeToast: () => void;
}

const NotificationCloseButton = ({ closeToast }: NotificationCloseButtonProps) => {
  return (
    <div onClick={closeToast} className={styles.container}>
      <CrossIcon className={styles.close_icon} />
    </div>
  );
};

export default NotificationCloseButton;
